import React from "react";
import Modal from "../../../../components/Modal";
import "./index.scss";

const DocApproveModal = ({ isOpen, docName, onClose, onConfirm }) => (
  <Modal
    isOpen={isOpen}
    onClose={onClose}
    title="Ready Approve Document"
    size="small"
  >
    <div className="doc-approve-modal">
      {/* Document name tag */}
      <div className="doc-approve-modal__doc-tag">
        <span className="doc-approve-modal__doc-icon">📄</span>
        <span className="doc-approve-modal__doc-name">{docName}</span>
      </div>

      {/* Check icon + message */}
      <div className="doc-approve-modal__body">
        <div className="doc-approve-modal__icon-wrap">
          <svg
            width="40"
            height="40"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
            <polyline points="22 4 12 14.01 9 11.01" />
          </svg>
        </div>
        <p className="doc-approve-modal__question">
          Have you reviewed this document?
        </p>
        <p className="doc-approve-modal__sub">
          Approving confirms the document is valid and complete.
        </p>
      </div>

      {/* Actions */}
      <div className="doc-approve-modal__actions">
        <button
          type="button"
          className="doc-approve-modal__btn-cancel"
          onClick={onClose}
        >
          Cancel
        </button>
        <button
          type="button"
          className="doc-approve-modal__btn-confirm"
          onClick={onConfirm}
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="20 6 9 17 4 12" />
          </svg>
          Yes
        </button>
      </div>
    </div>
  </Modal>
);

export default DocApproveModal;
